import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IAppBanner } from './app-banner.interface';

@Component({
    selector: 'mlp-ng-app-banner',
    templateUrl: './app-banner.component.html',
    styleUrls: ['./app-banner.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class AppBannerSharedComponent {
    @Input() appBanner: IAppBanner;
    @Input() backgroundImage = '/assets/img/recreate-background-banner-app.jpg';
    @Input() appPreviewImage = '/assets/img/phone-screens.png';

    @Input() downloadAndroid = 'https://play.google.com/store/apps/details?id=com.mylocalpitch';
    @Input() downloadIOS = 'https://itunes.apple.com/gb/app/mylocalpitch/id1020056658?pt=117881873&amp;mt=8';

    @Input() downloadAndroidImg = '/assets/banner/google-play-badge.svg';
    @Input() downloadIOSImg = '/assets/banner/download-app.svg';

    @Input() downloadAndroidImgAlt = 'andorid';
    @Input() downloadIOSImgAlt = 'ios';
    @Input() appPreviewImageAlt = 'playfinder app in phones';
}
